import React from "react";
import { Link } from "react-router-dom";
import ScrollToTop from "../components/ScrollToTop";

const TermsAndCondation: React.FC = () => {
  return (
    <div className="d-flex flex-column mb-5" style={{ height: '100%', backgroundColor: '#f8f6f0' }}>
      <ScrollToTop />

      {/* Breadcrumb */}
      <div className="py-3">
        <div className="container">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb mb-0" style={{ fontFamily: 'Satoshi, sans-serif' }}>
              <li className="breadcrumb-item">
                <Link to="/" className="text-decoration-none text-dark">
                  Home
                </Link>
              </li>
              <li
                className="breadcrumb-item fw_700 font-medium"
                aria-current="page"
              >
                Terms of Service
              </li>
            </ol>
          </nav>
        </div>
      </div>

      {/* Main Content */}
      <div className="container flex-grow-1 py-4">
        <div className="container flex-grow-1 d-flex flex-column flex-md-row py-4">
          {/* Left Content */}
          <div className="col-lg-4 col-md-5 mb-4 mb-md-0">
            <h1 className="mb-3" style={{ fontSize: '2.5rem', fontWeight: '500', color: '#2c3e50', fontFamily: 'Lora' }}>
                Final Checkout Terms & Conditions Agreement
            </h1>
            <p className="text-muted mb-0 font-satoshi" style={{ fontSize: '1.1rem', lineHeight: '1.6', fontFamily: 'Satoshi, sans-serif', textAlign:'justify' }}>
                Official terms and conditions governing your use of our website and digital products.
            </p>
            <p className="text-muted mt-2 font-satoshi" style={{ fontSize: '0.9rem', fontWeight: '500', fontFamily: 'Satoshi, sans-serif ' }}>
              Effective Date: January 2026
            </p>
          </div>

          <div>
            <hr className="mt-0" />
          </div>


          {/* Vertical Divider */}
          <div className="d-none d-lg-block" style={{
            padding: '0.5px',
            backgroundColor: '#112C3B4D',
            margin: '0 2rem',
            alignSelf: 'stretch'
          }}>
          </div>

          {/* Right Content */}
          <div className="col-lg-8 col-md-7">
            <div className="terms-content" style={{ lineHeight: '1.7', fontFamily: 'Satoshi, sans-serif', textAlign:'justify' }}>
                <p className="text-muted mb-4 font-satoshi" style={{ fontSize: '1rem', color: '#555', marginBottom: '0.5rem'}}>
                    Before completing your purchase, please carefully read and acknowledge the following terms. By clicking
                    “Place Order”, “Pay Now”, or any similar confirmation button,
                    you confirm that you have read, understood, and agreed to these terms.
                </p>

              {/* Section 1: No Returns, No Refunds Policy */}
              <div className="mb-4">
                <h3 style={{ fontSize: '1.2rem', fontWeight: '600', color: '#2c3e50', }}>
                  1. No Returns, No Refunds Policy
                </h3>
                <ul style={{ fontSize: '1rem', color: '#555', paddingLeft: '1.2rem', marginBottom: '0', listStyleType: 'disc' }}>
                  <li>All sales are final. Due to the digital nature of our products, once your order has been placed and payment is processed, no cancellations, returns, or refunds will be accepted.</li>
                  <li>Upon payment, your digital product (DigiVision Collection) will be automatically delivered to your registered email address or available for immediate download.</li>
                  <li>You acknowledge that once a digital file is accessed or downloaded, the transaction is complete and non-reversible.</li>
                  <li>For Canvas and physical art products offered through our affiliate partners, fulfillment, shipping, and quality control are handled directly by those third-party sellers. We are not responsible for shipping delays, product damages, or refund policies governed by affiliate vendors. Customers must refer to the partner's policy for those products.</li>
                </ul>
              </div>

              {/* Section 2: License & Usage of Digital Products */}
              <div className="mb-4">
                <h3 style={{ fontSize: '1.2rem', fontWeight: '600', color: '#2c3e50', }}>
                  2. License & Usage of Digital Products
                </h3>
                <ul style={{ fontSize: '1rem', color: '#555', paddingLeft: '1.2rem', marginBottom: '0', listStyleType: 'disc' }}>
                  <li>All digital files sold on DigiCartt are for personal, non-commercial use only, unless otherwise stated in writing.</li>
                  <li>You may not share, resell, distribute, modify, or reproduce any DigiVision product in any form.</li>
                  <li>Ownership of copyright and intellectual property remains solely with DigiCartt.</li>
                </ul>
              </div>

              {/* Section 3: Confirmation of Accuracy */}
              <div className="mb-4">
                <h3 style={{ fontSize: '1.2rem', fontWeight: '600', color: '#2c3e50', }}>
                  3. Confirmation of Accuracy
                </h3>
                <ul style={{ fontSize: '1rem', color: '#555', paddingLeft: '1.2rem', marginBottom: '0', listStyleType: 'disc' }}>
                  <li>You confirm that all billing information, including your name, email address, and payment method, is accurate and complete.</li>
                  <li>Errors resulting from incorrect customer information are not eligible for refunds or adjustments.</li>
                </ul>
              </div>

              {/* Section 4: Third-Party Fulfillment (Affiliate Products) */}
              <div className="mb-4">
                <h3 className="" style={{ fontSize: '1.2rem', fontWeight: '600', color: '#2c3e50', }}>
                  4. Third-Party Fulfillment (Affiliate Products)
                </h3>
                <ul style={{ fontSize: '1rem', color: '#555', paddingLeft: '1.2rem', marginBottom: '0', listStyleType: 'disc' }}>
                  <li>If your purchase includes a physical artwork, you understand that DigiCartt acts as an affiliate referrer, not the seller of record.</li>
                  <li>You will be redirected or connected to a third-party website to complete your transaction.</li>
                  <li>DigiCartt does not control or manage their shipping, return, or privacy policies, and is not liable for any issues arising from affiliate transactions.</li>
                </ul>
              </div>

              {/* Section 5: Acceptance of Legal Policies */}
              <div className="mb-4">
                <h3 className="" style={{ fontSize: '1.2rem', fontWeight: '600', color: '#2c3e50', }}>
                  5. Acceptance of Legal Policies
                </h3>
                <p style={{ fontSize: '1rem', color: '#555', marginBottom: '1rem' }}>
                  By completing your purchase, you confirm that you have read and agreed to:
                </p>
                <ul style={{ fontSize: '1rem', color: '#555', paddingLeft: '1.2rem', marginBottom: '0', listStyleType: 'disc' }}>
                  <li>DigiCartt's Terms of Service</li>
                  <li>DigiCartt's Privacy Policy</li>
                  <li>No Returns / No Refunds Policy (this document)</li>
                </ul>
                <p style={{ fontSize: '1rem', color: '#555', marginTop: '1rem', marginBottom: '0' }}>
                  You also acknowledge that these policies are available for your review at any time on [yourwebsite.com/policies].
                </p>
              </div>

              {/* Section 6: Acknowledgment */}
              <div className="mb-0">
                <h3 className="" style={{ fontSize: '1.2rem', fontWeight: '600', color: '#2c3e50', }}>
                  6. Acknowledgment
                </h3>
                <p style={{ fontSize: '1rem', color: '#555', marginBottom: '1rem' }}>
                  By proceeding with payment, you expressly agree to:
                </p>
                <ul style={{ fontSize: '1rem', color: '#555', paddingLeft: '1.2rem', marginBottom: '1rem', listStyleType: 'none' }}>
                  <li style={{ marginBottom: '0.5rem' }}>✅ Be bound by all DigiCartt policies listed above.</li>
                  <li style={{ marginBottom: '0.5rem' }}>✅ Waive any chargeback or dispute claim for "non-delivery" once the digital file has been sent to your provided email.</li>
                  <li style={{ marginBottom: '0.5rem' }}>✅ Accept that all purchases are final, non-transferable, and non-refundable.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndCondation;
